import { render } from "./TemplateActions.vue?vue&type=template&id=375aba3a&scoped=true"
import script from "./TemplateActions.vue?vue&type=script&lang=js"
export * from "./TemplateActions.vue?vue&type=script&lang=js"

import "./TemplateActions.vue?vue&type=style&index=0&id=375aba3a&scoped=true&lang=scss"

import exportComponent from "/workspace/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-375aba3a"]])

export default __exports__